import React from 'react';
import BetaLayout from '../beta/BetaLayout';

// 翻頁只發生在 beta-view-content(保留 sidebar/topbar 外殼),
// 由 BetaLayout 依 ?v=new 決定內容區渲染舊 view 或新 WorkItemApp。
const MainLayout = () => {
  return <BetaLayout />;
};

export default MainLayout;
